import React from 'react';
import { ConnectedRouter } from 'react-router-redux';

import history from 'core/store/history';
import ReactGA from "react-ga4";

const Router: React.SFC = ({children}): any => {
	// To send routepath to google analytics 4 
	history.listen((location, action) => {
		ReactGA.set({ page: location.pathname });
		ReactGA._gaCommandSendPageview(location.pathname, null);
	});
	
	return (
		<ConnectedRouter history={history}>
			{children}
		</ConnectedRouter>
	);
};

export default Router;



// WEBPACK FOOTER //
// ./src/core/components/Router.tsx